export const providersInformation = [
    {
        provider: 'google',
        label: window.i18n.__('Google Authenticator / Microsoft Authenticator / Authy'),
        description: window.i18n.__(
            'Ces application ne nécessitent aucun compte pour générer les codes de sécurité.',
        ),
        type: window.i18n.__("Application d'authentification"),
        button: window.i18n.__('Activer la 2FA'),
    },
    {
        provider: 'email',
        label: window.i18n.__('Adresse email'),
        description:
            'Utilisez cette méthode si vous souhaitez recevoir les codes de sécurité sur une adresse email.',
        type: window.i18n.__('Email'),
        icon: 'envelope',
        button: window.i18n.__('Utiliser un email'),
    },
    {
        provider: 'sms',
        label: window.i18n.__('Téléphone (SMS)'),
        description: window.i18n.__(
            'Utilisez cette méthode si vous souhaitez recevoir les codes de sécurité par texto (SMS) sur un téléphone portable.',
        ),
        type: window.i18n.__('Texto (SMS)'),
        icon: 'phone',
        button: window.i18n.__('Utiliser les textos (SMS)'),
    },
];
